import { AdminSectionName } from "@app/enumerations";

export default class AdminAppLink {
	public id: string = '';
	public isRouter: boolean = false;
	public label?: string;
	public subLinks: AdminAppLink[] = [];
	public url?: string;
	public adminSectionName?: AdminSectionName;
	
	public constructor() {

	}
};